import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { SubHeaderDTO, ActionElementDTO, ActionInterface, ActionGroupElementDTO } from './sub-header.dtos';
import { HeaderActionsService } from './header-actions.service';
import { BaseComponent } from '../baseComponent/base.component';
import { MenuItem } from 'primeng-lts/api';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as lodash from 'lodash';

declare var jQuery: any;


@Component({
  selector: 'sub-header',
  templateUrl: 'sub-header.template.html'
})


export class SubHeaderComponent extends BaseComponent implements OnDestroy, AfterViewInit {


  @Input()
  isModal = false;

  @Input()
  includeContextHelp = false;

  @Input() windowHash: string;

  @Input() dataLoaded = true;

  headerData: SubHeaderDTO

  private subscription: Subscription;

  // @ViewChild('headercontainer', { static: true })
  // public headerRef: ElementRef;

  private items: MenuItem[];
  public groupActions = [];
  /*
    @ViewChild('headercontainer');
    set headercontainer(headerRef: ElementRef)
    {
      this.headerRef = headerRef;
    }
  */
  constructor(private headerActionsService: HeaderActionsService, private translateService: TranslateService, private elem: ElementRef) {
    super();
  }

  ngAfterViewInit() {
    this.subscription = this.subscribe(this.headerActionsService.getConfig(), data => {
      this.headerData = data;
      if (this.headerData && this.headerData.windowactions
        && this.headerData.windowactions.get(this.windowHash)
        && this.headerData.windowactions.get(this.windowHash).length > 0) {
        jQuery(this.elem.nativeElement).closest('.p-dialog-content').addClass('with-sub-header');
      } else {
        jQuery(this.elem.nativeElement).closest('.p-dialog-content').removeClass('with-sub-header');
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public fireAction(item: ActionElementDTO) {
    item.action.next(true);
  }

  public getTaskIcon() {
    if (this.headerData) {
      return this.headerData.taskIcon;
    }
  }

  public loadGroupActions(group: ActionGroupElementDTO): MenuItem[] {
    let items = new Array<MenuItem>();
    if (group.actions != null) {
      group.actions.forEach(action => {
        let item = {
          label: this.translateService.instant(action.name),
          icon: action.icon,
          command: () => {
            action.action.next(true)
          },
          disabled: !this.isActionEnabled(action),
          visible: this.isActionVisible(action),
          tooltip: this.buttonTooltip(action)
        }
        items.push(item);
      });
      this.items = items;
    }
    this.groupActions = this.items;
    return this.items;
  }

  public isActionVisible(action: ActionInterface): boolean {
    return action.visible && (!(action.visible instanceof Function) || action.visible());
  }

  public isActionEnabled(action: ActionInterface): boolean {
    return action.enable == undefined || (action.enable && (!(action.enable instanceof Function) || action.enable()));
  }

  public buttonTooltip(action: ActionInterface): string {
    if (this.isActionEnabled(action) || !action.disableTooltip) {
      return action.name;
    } else {
      return action.disableTooltip;
    }
  }

  public isActionGroup(action: ActionInterface): boolean {
    return action instanceof ActionGroupElementDTO || action['id'];
  }
}
